/* eslint-disable import/prefer-default-export */
export { default as useBLazyRevalidate } from './useBLazyRevalidate';
